'use es6';

import Widget from 'DesignData/models/widgets/Widget';
import ContentAvailability from 'DesignData/models/widgets/utils/ContentAvailability';
const privy = new WeakMap();
/**
 */

export default class GlobalGroup extends Widget {
  /**
   * @constructor
   */
  constructor(props) {
    return super(props).without('layoutData').set('type', 'global_group');
  }

  get contentAvailability() {
    let contentAvailability = privy.get(this);

    if (!contentAvailability) {
      const options = {
        isGlobalGroup: true
      };
      contentAvailability = new ContentAvailability(this, options);
      privy.set(this, contentAvailability);
    }

    return contentAvailability;
  }

  get isDisabled() {
    return !this.isAvailableForNewContent;
  }
  /**
   * Returns an object widget with minimum requirements for use in a layout's tree.
   *
   * @override
   * @return {Object}
   */


  generateNewLayoutWidgetObject() {
    const path = this.generatedTemplatePath || this.path;
    const superWidgetObject = super.generateNewLayoutWidgetObject();
    return Object.assign({}, superWidgetObject, {
      params: Object.assign({}, superWidgetObject.params, {
        path,
        overrideable: false
      })
    });
  }

}